export default __webpack_public_path__ + "static/media/endRound14.0d4e848a.mp3";